const URL_REGEX = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;

export default function urlifyText(text) {
    return text.replace(URL_REGEX, (url) => {
        return `<a href="${url}" target="_blank">${url}</a>`;
    });
};